import React from "react";
import { Redirect, useLocation } from "react-router-dom";

// Segmentos de URL que antes iban en camelCase y ahora van en kebab-case.
const LEGACY_SEGMENTS = {
  commonCosts: "common-costs",
  commonIncome: "common-income",
  individualCosts: "individual-costs",
  individualIncome: "individual-income",
  invividualIncome: "individual-income",
  currentFund: "current-fund",
  paymentFund: "payment-fund",
  paymentReserveFund: "payment-reserve-fund",
  paymentsProvider: "payments-provider",
  paymentsProviderPaid: "payments-provider-paid",
  reserveFund: "reserve-fund",
  topayProvider: "topay-provider",
};

// Movimientos de ruta posteriores al paso a kebab-case: la sección
// /dashboard/reserve pasó a llamarse /dashboard/funds y sus hijos se
// acortaron, en finance/accounting la colección quedó en plural, y "detail",
// "show" y "details" dejaron de ser un segmento propio (el id ya identifica
// al recurso). El orden importa: lo específico va antes que el prefijo suelto.
const LEGACY_PATHS = [
  [/^\/dashboard\/reserve\/(\d+)\/reserve-fund/, "/dashboard/funds/$1/reserve"],
  [/^\/dashboard\/reserve\/(\d+)\/current-fund/, "/dashboard/funds/$1/cash"],
  [/^\/dashboard\/reserve/, "/dashboard/funds"],
  [/^(\/dashboard\/(?:finance|accounting)\/\d+)\/reserve-fund(?!s)/, "$1/reserve-funds"],
  [/^(\/dashboard\/(?:finance|accounting)\/\d+\/reserve-funds)\/detail\/(\d+)/, "$1/$2"],
  [/^(\/dashboard\/visitors\/\d+)\/details$/, "$1"],
  // La pantalla de un efecto por cobrar es solo lectura (HO-TASK-250):
  // dejó de llamarse "edit".
  [/^(\/dashboard\/(?:finance|accounting|funds)\/\d+\/receivable)\/edit\/(\d+)/, "$1/detail/$2"],
  [/^\/root\/support\/show\/(\d+)/, "/root/support/$1"],
  [/^(\/root\/condominiums\/\d+\/payments\/[^/]+)\/show\/(\d+)/, "$1/$2"],
];

export const normalizeLegacyPath = (pathname) => {
  const kebab = pathname
    .split("/")
    .map((segment) => LEGACY_SEGMENTS[segment] || segment)
    .join("/");

  return LEGACY_PATHS.reduce(
    (acc, [pattern, replacement]) => acc.replace(pattern, replacement),
    kebab
  );
};

// Se usa como último hijo de un <Switch>: si la ruta trae una forma vieja la
// reescribe y redirige, y si no, cae al 404 de siempre. Los enlaces guardados
// antes del cambio (favoritos, correos, la última ruta persistida en el store)
// siguen abriendo la pantalla correcta.
const LegacyRouteRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const normalized = normalizeLegacyPath(pathname);

  if (normalized === pathname) return <Redirect to="/errors/404" />;

  return <Redirect to={`${normalized}${search}${hash}`} />;
};

export default LegacyRouteRedirect;
